import {Fragment, useEffect, useState} from "react";
import {Grid} from "@mui/material";
import {imgAutoBus} from "../img/ImgBarrel";
import {CardItemComponent} from "./Manual/CardItem";

export function ShipOnMechanicalComponent({selected=null}){

    const [report] = useState([]);
    const [ships, setships] = useState([
            ...checkTallerSelected(selected.text)
    ]);

    useEffect(() => {

        setships([
            ...checkTallerSelected(selected.text)
        ])
        // eslint-disable-next-line
    }, [selected.text]);


    function checkTallerSelected(nameSelected){
        let shipOnTaller = report.filter((things)=> things?.taller?.label === nameSelected);
        let formatShip = [];
        for (let index = 0; index < shipOnTaller.length; index++) {
            let ship = shipOnTaller[index];
            formatShip.push({
                name: ship.datosUnidad.label,
                img: imgAutoBus.default,
                dataShip: ship
            });
        }

        let number_ship = nameSelected === "Taller 3"? 28:26;
        for (let index = formatShip.length; index < number_ship; index++) {
            formatShip.push({
                name: "nave vacia",
                img: imgAutoBus.default
            });
        }

        return formatShip;
    }

    const handlingClikShip =(thingsShip) =>{
        console.log("thingsShip →", thingsShip);
    }


    return(
        <Fragment>
            {
                ships.map((shiprow, index)=>(
                    <Grid item xs={2} key={`Card-index-${index}`}>
                        <CardItemComponent
                            thingsData={shiprow}
                            handlingClickItem={handlingClikShip}
                        />

                    </Grid>
                ))
            }
        </Fragment>
    );
}